/**
 * Budget progress bar (Phase 3, §6.2). A horizontal bar filled to `barPct`
 * (capped at 100), coloured by band — emerald (≤80) / amber (80–100) /
 * rose (>100) — with an overflow marker at the right edge when over budget.
 */
import type { ProgressBand } from './budgetMath.ts';

const FILL: Record<ProgressBand, string> = {
  ok: 'bg-emerald-500 dark:bg-emerald-400',
  warn: 'bg-amber-500 dark:bg-amber-400',
  over: 'bg-rose-500 dark:bg-rose-400',
};

export interface BudgetProgressBarProps {
  barPct: number;
  band: ProgressBand;
  /** Percent of budget spent (for the a11y label); 0 when no budget. */
  pct: number;
}

export function BudgetProgressBar({ barPct, band, pct }: BudgetProgressBarProps) {
  return (
    <div
      className="relative h-2 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
    >
      <div
        className={`h-full rounded-full transition-[width] ${FILL[band]}`}
        style={{ width: `${barPct}%` }}
      />
      {band === 'over' ? (
        <span
          aria-hidden
          className="absolute inset-y-0 right-0 w-1 bg-rose-700 dark:bg-rose-300"
        />
      ) : null}
    </div>
  );
}
